module.exports = __webpack_public_path__ + "static/media/max-green.a33c861e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/airpods/max-green.png
// module id = 2058
// module chunks = 0